module.exports = __webpack_public_path__ + "img/vk.5a9be33.svg?v=1764903765445";